var exports = {
  "k": "x52a3aa3b--5490ae--container",
  "x": "x52a3aa3b--5490ae--button",
};

module.exports = exports;
